import addTargetEventListener from './events/addTargetEventListener';
import 'element-closest-polyfill';

export function handleClick(event) {
  event.preventDefault();
  const sessionReview = event.target.closest('.mc-session-review');
  if (sessionReview) {
    sessionReview.classList.add('mc-session-review--more');
  }
}

addTargetEventListener('click', '.mc-session-review__more', handleClick);
